import type { Schemas } from '#shopware'
import { mediaIncludes } from './media'

export const propertyGroupOptionIncludes: Schemas['Includes'] = {
    property_group_option: ['id', 'name', 'translated', 'colorHexCode', 'media', 'configuration'],
    ...mediaIncludes,
}

export const propertyGroupIncludes: Schemas['Includes'] = {
    property_group: [
        'id',
        'customFields.custom_configurator_names_name',
        'customFields.custom_characteristic_size_chart_id',
        'customFields.custom_property_group_info_trigger',
        'customFields.custom_property_group_info_target',
        'customFields.custom_property_group_info_type',
        'customFields.custom_relevant_for_sizekick_toggle',
        'customFields.custom_property_group_info_display_listing_card',
        'name',
        'displayType',
        'options',
        'translated',
        'customPropertyFilter',
    ],
    ...propertyGroupOptionIncludes,
}
